import { Component, OnInit } from '@angular/core'
import { OffersService } from '../../services/offers.service'
import { Subscription } from 'rxjs'
import { Router } from '@angular/router'
import { SharedService } from 'src/app/shared/services/shared.service'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { MatDialog } from '@angular/material/dialog'

@Component({
	selector: 'app-add-promo-code',
	templateUrl: './add-promo-code.component.html',
	styleUrls: ['./add-promo-code.component.scss'],
})
export class AddPromoCodeComponent implements OnInit {
	subscription = new Subscription()
	isBasicInfoInvalid = true
	countryPriceInvalid = true
	breadCrumbRout: any
	constructor(
		private offerService: OffersService,
		private dialog: MatDialog,
		private router: Router,
		private sharedServ: SharedService
	) {
		this.sharedServ.handleBreadCrumb('add-promo-code', false, {
			name: '',
			id: null,
			url: '',
			queryParams:null,
		})
	}
	addOfferData: any = []
	ngOnInit(): void {}

	addPromoCode() {
		this.addOfferData.endDate = this.sharedServ.handleDate(
			this.addOfferData.endDate
		)
		this.addOfferData.startDate = this.sharedServ.handleDate(
			this.addOfferData.startDate
		)
		this.subscription.add(
			this.offerService.AddPromoCode(this.addOfferData).subscribe((res) => {
				this.router.navigate(['/layout/offer/'])
			})
		)
	}
	dataChanged(event: any) {
		this.addOfferData = {
			...this.addOfferData,
			...event,
		}
	}
	openDialog() {
		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '385px',
				// height: '340px',
				data: {
					notflex: true,
					image: 'assets/images/Frame.svg',
					message: 'CONFIRMATION_MESSAGE.ARE_YOU_SURE_TO_CANCEL',
					cancelBtn: 'ACTIONS.NO',
					confirmBtn: 'ACTIONS.YES',
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					res
						? this.router.navigate(['/layout/offer/'])
						: this.dialog.closeAll()
				},
			})
	}
	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
